<template>
    <modal
        class="language-modal"
        title="Select a new language"
        header-bg-variant="blue-600"
        header-text-variant="white"
        :hide-header-close="true"
        @ok="onConfirm"
        @hide="onCancel"
    >
        <dropdown v-model="newLanguage" :options="newLanguageOptions" />

        <template v-slot:modal-footer="slotProps">
            <button class="flex-modal__button flex-modal__button--cancel" @click="slotProps.hide('cancel')">
                Cancel
            </button>

            <button class="flex-modal__button flex-modal__button--continue" @click="slotProps.hide('ok')">
                Select
            </button>
        </template>
    </modal>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import { SCREEN_NAMES } from '@/data/constants/screen';
import { getLanguages, ERROR } from '@/sitecore/sitecore-data-service';
import { SAVE_LANGUAGE_VERSION, LOAD_PAGE } from '@/store/types/action-types';
import { SHOW_ALERT, TOGGLE_PAGE_LOADING } from '@/store/types/mutation-types';

export default {
    name: 'language-modal',

    data() {
        return {
            newLanguages: [],
            newLanguage: '',
            selected: '',
            lastSelected: '',
        };
    },

    computed: {
        ...mapState({
            pageData: state => state.page.pageData,
        }),

        newLanguageOptions() {
            const existingLanguages = this.pageData && this.pageData.pageData.languages;

            if (!existingLanguages) return [];

            return this.newLanguages
                .filter(newLang => !existingLanguages[newLang.id])
                .map(newLang => ({ text: newLang.title, value: newLang.id }));
        },
    },

    created() {
        this.getAllLanguages();
    },

    methods: {
        ...mapActions({
            saveLanguageVersion: SAVE_LANGUAGE_VERSION,
            loadPage: LOAD_PAGE,
        }),

        ...mapMutations({
            showAlert: SHOW_ALERT,
            togglePageLoading: TOGGLE_PAGE_LOADING,
        }),

        async getAllLanguages() {
            const response = await getLanguages();

            if (response.status === ERROR) {
                this.showAlert({ description: response.error });
                return;
            }

            this.newLanguages = response.data;
        },

        async onConfirm() {
            this.togglePageLoading({ loading: true });

            // we need to load page because our save does not reload and refresh datasource IDs
            await this.loadPage({ pageId: this.pageData.pageData.id, lang: this.getCurrentLanguage() });

            await this.saveLanguageVersion({
                mode: this.screen === SCREEN_NAMES.TEMPLATE_EDITOR ? 'templates' : 'page',
                lang: this.newLanguage,
            });

            this.loadSelection(this.newLanguage);

            // need to wait for new language to be loaded into dropdown
            // page load takes longer so this does not affect UX
            setTimeout(() => {
                this.$root.$emit('flex::language::update', this.newLanguage);
            }, 500);

            this.togglePageLoading({ loading: false });
        },

        loadSelection(lang) {
            this.$root.$emit('flex::page::load', lang);
        },

        onCancel() {
            this.$root.$emit('flex::language::update');
        },

        getCurrentLanguage() {
            if (!this.pageData) {
                return this.$route.query.lang || 'en';
            }

            return this.pageData.pageData.language;
        },
    },
};
</script>
